import ModuleHero from './ModuleHero';

export default ModuleHero;
export * from './ModuleHero';
